import styled from 'styled-components'
import { Typography } from '@mui/material'

export const FilterByLabelStyles = styled(Typography)`
  min-width: max-content;
`
